import { userMachineCatalogueActions } from "../../constants/actionTypes";

const getCatalogLabsListData = (data) => ({
  type: userMachineCatalogueActions.FETCH_CATALOG_LABS_LIST_DATA,
  payload: data,
});

const setCatalogLabsListData = (data) => ({
  type: userMachineCatalogueActions.SET_CATALOG_LABS_LIST_DATA,
  payload: data,
});

const setCatalogLabsListError = (data) => ({
  type: userMachineCatalogueActions.SET_CATALOG_LABS_LIST_ERROR,
  payload: data,
});

const labViewRequest = (data, isManageVm, tenantId) => ({
  type: userMachineCatalogueActions.LAB_VIEW_REQUEST,
  payload: { data, isManageVm, tenantId },
});

const labViewSuccess = (data) => ({
  type: userMachineCatalogueActions.LAB_VIEW_SUCCESS,
  payload: data,
});

const labViewError = (data) => ({
  type: userMachineCatalogueActions.LAB_VIEW_ERROR,
  payload: data,
});

const createVmRequest = (data) => ({
  type: userMachineCatalogueActions.CREATE_VM_REQUEST,
  payload: data,
});

const createVmRequestAdmin = (data) => ({
  type: userMachineCatalogueActions.CREATE_VM_REQUEST_ADMIN,
  payload: data,
});

const createVmSuccess = (data) => ({
  type: userMachineCatalogueActions.CREATE_VM_SUCCESS,
  payload: data,
});

const createVmError = (data) => ({
  type: userMachineCatalogueActions.CREATE_VM_ERROR,
  payload: data,
});

const removeSelectedLab = () => ({
  type: userMachineCatalogueActions.REMOVE_SELECTED_LAB,
});

const setVMADDStatus = (data) => ({
  type: userMachineCatalogueActions.SET_VM_ADD_STATUS,
  payload: data,
});

const resetQuotaValueRequest = (data) => ({
  type: userMachineCatalogueActions.QUOTA_RESET_VALUE_REQUEST,
  payload: data,
});

const resetQuotaValueSuccess = (data) => ({
  type: userMachineCatalogueActions.QUOTA_RESET_VALUE_SUCCESS,
  payload: data,
});

const resetQuotaValueError = (error) => ({
  type: userMachineCatalogueActions.QUOTA_RESET_VALUE_ERROR,
  payload: error,
});

const requestCloudCatalogList = (data) => ({
  type: userMachineCatalogueActions.REQUEST_CLOUD_CATALOG_LIST,
  payload: data,
});

const successCloudCatalogList = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CLOUD_CATALOG_LIST,
  payload: data,
});

const errorCloudCatalogList = (data) => ({
  type: userMachineCatalogueActions.ERROR_CLOUD_CATALOG_LIST,
  payload: data,
});

const cloudCatalogViewRequest = (id, urlParams) => ({
  type: userMachineCatalogueActions.REQUEST_CLOUD_CATALOG,
  payload: { id, urlParams },
});

const successCloudCatalog = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CLOUD_CATALOG,
  payload: data,
});

const errorCloudCatalog = (data) => ({
  type: userMachineCatalogueActions.ERROR_CLOUD_CATALOG,
  payload: data,
});

const requestCloudLabExtension = (data) => ({
  type: userMachineCatalogueActions.REQUEST_CLOUD_LAB_EXTENSION,
  payload: data,
});

const successCloudLabExtension = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CLOUD_LAB_EXTENSION,
  payload: data,
});

const errorCloudLabExtension = (data) => ({
  type: userMachineCatalogueActions.ERROR_CLOUD_LAB_EXTENSION,
  payload: data,
});

const requestCreateCloudLab = (data) => ({
  type: userMachineCatalogueActions.REQUEST_CREATE_CLOUD_LAB,
  payload: data,
});

const successCreateCloudLab = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CREATE_CLOUD_LAB,
  payload: data,
});

const errorCreateCloudLab = (data) => ({
  type: userMachineCatalogueActions.ERROR_CREATE_CLOUD_LAB,
  payload: data,
});

const requestCloudLabList = (data) => ({
  type: userMachineCatalogueActions.REQUEST_CLOUD_LAB_LIST,
  payload: data,
});

const successCloudLabList = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CLOUD_LAB_LIST,
  payload: data,
});

const errorCloudLabList = (data) => ({
  type: userMachineCatalogueActions.ERROR_CLOUD_LAB_LIST,
  payload: data,
});

const requestCreateCloudLabFeedback = (data) => ({
  type: userMachineCatalogueActions.REQUEST_CREATE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const successCreateCloudLabFeedback = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_CREATE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const errorCreateCloudLabFeedback = (data) => ({
  type: userMachineCatalogueActions.ERROR_CREATE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const requestUpdateCloudLabFeedback = (data, id) => ({
  type: userMachineCatalogueActions.REQUEST_UPDATE_CLOUD_LAB_FEEDBACK,
  payload: data,
  id: id,
});

const successUpdateCloudLabFeedback = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_UPDATE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const errorUpdateCloudLabFeedback = (data) => ({
  type: userMachineCatalogueActions.ERROR_UPDATE_CLOUD_LAB_FEEDBACK,
  payload: data,
});

const setBaseTemplateList = (data) => ({
  type: userMachineCatalogueActions.SET_BASE_TEMPLATES_LIST,
  payload: data,
});

const getBaseTemplateList = (data) => ({
  type: userMachineCatalogueActions.GET_BASE_TEMPLATES_LIST,
  payload: data,
});

const setLoadingBaseTemplates = (data) => ({
  type: userMachineCatalogueActions.LOADING_BASE_TEMPLATE_LIST,
  payload: data,
});

const updateBaseTemplate = (data) => ({
  type: userMachineCatalogueActions.UPDATE_BASE_TEMPLATE,
  payload: data,
});

const updateBaseTemplateSuccessAction = (data) => ({
  type: userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_SUCCESS,
  payload: data,
});

const updateBaseTemplateErrorAction = (data) => ({
  type: userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_ERROR,
  payload: data,
});

const updateBaseTemplateLoadingAction = (data) => ({
  type: userMachineCatalogueActions.UPDATE_BASE_TEMPLATE_LOADING,
  payload: data,
});

const getExtensionAndBasePackAction = (data) => ({
  type: userMachineCatalogueActions.GET_EXTENSION_AND_BASE_PACKS_ACTION,
  payload: data,
});

const setExtensionAndBasePackAction = (data) => ({
  type: userMachineCatalogueActions.SET_EXTENSION_AND_BASE_PACKS_ACTION,
  payload: data,
});

const setExtensionAndBasePackLoadingAction = (data) => ({
  type: userMachineCatalogueActions.SET_EXTENSION_AND_BASE_PACKS_LOADING_ACTION,
  payload: data,
});

const applyLabExtension = (data) => ({
  type: userMachineCatalogueActions.APPLY_LAB_EXTENSION,
  payload: data,
});

const applyLabExtensionSuccess = (data) => ({
  type: userMachineCatalogueActions.APPLY_LAB_EXTENSION_SUCCESS,
  payload: data,
});

const applyLabExtensionError = (data) => ({
  type: userMachineCatalogueActions.APPLY_LAB_EXTENSION_ERROR,
  payload: data,
});

const applyLabExtensionLoading = (data) => ({
  type: userMachineCatalogueActions.APPLY_LAB_EXTENSION_LOADING,
  payload: data,
});

const setSelectedTemplateType = (data) => ({
  type: userMachineCatalogueActions.SET_SELECTED_TEMPLATE_TYPE,
  payload: data,
});

const exportSkuTenantCatalog = (data) => ({
  type: userMachineCatalogueActions.EXPORT_SKU_TENANT_CATALOG,
  payload: data,
});

const successExportSkuTenantCatalog = (data) => ({
  type: userMachineCatalogueActions.SUCCESS_EXPORT_SKU_TENANT_CATALOG,
  payload: data,
});

const errorExportSkuTenantCatalog = (data) => ({
  type: userMachineCatalogueActions.ERROR_EXPORT_SKU_TENANT_CATALOG,
  payload: data,
});

const clearExportSkuTenantCatalog = () => ({
  type: userMachineCatalogueActions.CLEAR_EXPORT_SKU_TENANT_CATALOG,
});

const applyCloudLabExtensionLoading = (payload) => ({
  type: userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_LOADING,
  payload: payload
});

const applyCloudLabExtensionAction = (payload) => ({
  type: userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_ACTION,
  payload: payload
});

const applyCloudLabExtensionSuccess = (payload) => ({
  type: userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_SUCCESS,
  payload: payload
});

const applyCloudLabExtensionError = (payload) => ({
  type: userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_ERROR,
  payload: payload
});

const applyCloudLabExtensionReset = (payload) => ({
  type: userMachineCatalogueActions.APPLY_CLOUD_LAB_EXTENSION_RESET,
  payload: payload
});

export {
  getCatalogLabsListData,
  setCatalogLabsListData,
  setCatalogLabsListError,
  labViewRequest,
  labViewSuccess,
  labViewError,
  createVmRequest,
  createVmSuccess,
  createVmError,
  removeSelectedLab,
  setVMADDStatus,
  resetQuotaValueRequest,
  resetQuotaValueSuccess,
  resetQuotaValueError,
  requestCloudCatalogList,
  successCloudCatalogList,
  errorCloudCatalogList,
  requestCloudLabExtension,
  successCloudLabExtension,
  errorCloudLabExtension,
  requestCreateCloudLab,
  successCreateCloudLab,
  errorCreateCloudLab,
  requestCloudLabList,
  successCloudLabList,
  errorCloudLabList,
  requestCreateCloudLabFeedback,
  successCreateCloudLabFeedback,
  errorCreateCloudLabFeedback,
  requestUpdateCloudLabFeedback,
  successUpdateCloudLabFeedback,
  errorUpdateCloudLabFeedback,
  createVmRequestAdmin,
  setBaseTemplateList,
  getBaseTemplateList,
  setLoadingBaseTemplates,
  updateBaseTemplate,
  updateBaseTemplateSuccessAction,
  updateBaseTemplateErrorAction,
  updateBaseTemplateLoadingAction,
  getExtensionAndBasePackAction,
  setExtensionAndBasePackAction,
  setExtensionAndBasePackLoadingAction,
  applyLabExtensionError,
  applyLabExtensionSuccess,
  applyLabExtensionLoading,
  applyLabExtension,
  setSelectedTemplateType,
  exportSkuTenantCatalog,
  successExportSkuTenantCatalog,
  errorExportSkuTenantCatalog,
  clearExportSkuTenantCatalog,
  cloudCatalogViewRequest,
  successCloudCatalog,
  errorCloudCatalog,
  applyCloudLabExtensionLoading,
  applyCloudLabExtensionAction,
  applyCloudLabExtensionSuccess,
  applyCloudLabExtensionError,
  applyCloudLabExtensionReset
};
